import { render, staticRenderFns } from "./EditPublicationModal.vue?vue&type=template&id=2bb59b58&"
import script from "./EditPublicationModal.vue?vue&type=script&lang=js&"
export * from "./EditPublicationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports